<template>
	<div v-if="load" id="loading" class="load-wrapp">
		<div class="load-9">
			<div class="spinner">
				<div class="bubble-1"></div>
				<div class="bubble-2"></div>
			</div>
			<p class="loadingText">{{ $t('common.loading') }}</p>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			show: true, load: true
		}
	},
	mounted() {
		window.onload = () => {	
			this.load = false;
		}
	},
	computed: {
	}
}

</script>
<style>

</style>